import React from "react";
import "./skillsCard.scss";

const SkillsCard = ({ icon, title, data }) => {
  return (
    <div className="skillscard">
      <div className="skillCard__box">
        <div className="skillCard__iconHeader">
          <i className={icon}></i>
          <h3 className="skillCard__title">{title}</h3>
        </div>

        <div className="skillCard__items">
          {data.map((item, index) => {
            return (
              <div className="skillCard__item" key={index}>
                <i className={item.icon}></i>
                <span className="skillCard__name">{item.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SkillsCard;
